import { render, staticRenderFns } from "./HotelGroupChainPortalSidenav.vue?vue&type=template&id=2998e884"
import script from "./HotelGroupChainPortalSidenav.vue?vue&type=script&lang=js"
export * from "./HotelGroupChainPortalSidenav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports